import { render, staticRenderFns } from "./CustomersList.vue?vue&type=template&id=428452cd&scoped=true"
import script from "./CustomersList.vue?vue&type=script&lang=js"
export * from "./CustomersList.vue?vue&type=script&lang=js"
import style0 from "./CustomersList.vue?vue&type=style&index=0&id=428452cd&prod&lang=scss&scoped=true"
import style1 from "./CustomersList.vue?vue&type=style&index=1&id=428452cd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428452cd",
  null
  
)

export default component.exports